(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Translation strings
    const removeConfirmText = 'Are you sure you want to remove this item?';
    const updatingText = 'Updating...';

    // Quantity controls
    const quantityMinusBtns = document.querySelectorAll('[data-quantity-minus]');
    const quantityPlusBtns = document.querySelectorAll('[data-quantity-plus]');
    const quantityInputs = document.querySelectorAll('[data-quantity-input]');

    // Handle quantity decrease
    quantityMinusBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const input = this.parentElement.querySelector('[data-quantity-input]');
        const currentValue = parseInt(input.value);
        if (currentValue > 0) {
          input.value = currentValue - 1;
          // Auto-update cart when quantity changes
          updateCart();
        }
      });
    });

    // Handle quantity increase
    quantityPlusBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const input = this.parentElement.querySelector('[data-quantity-input]');
        const currentValue = parseInt(input.value);
        input.value = currentValue + 1;
        // Auto-update cart when quantity changes
        updateCart();
      });
    });

    // Handle direct input changes
    quantityInputs.forEach(input => {
      input.addEventListener('change', function() {
        const value = parseInt(this.value);
        if (value < 0) {
          this.value = 0;
        }
        // Auto-update cart when quantity changes
        updateCart();
      });
    });

    // Remove item functionality
    const removeBtns = document.querySelectorAll('[data-cart-remove]');
    removeBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (confirm(removeConfirmText)) {
          window.location.href = this.href;
        }
      });
    });

    // Checkout button functionality
    const checkoutBtn = document.querySelector('[data-checkout-btn]');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function(e) {
        // Let the link work normally - Shopify will handle the checkout
        // No need to prevent default or do anything special
      });
    }

    // Auto-update cart function
    function updateCart() {
      const form = document.querySelector('[data-cart-form]');
      if (form) {
        // Show loading state
        const updateBtn = form.querySelector('.cart-update-btn');
        if (updateBtn) {
          updateBtn.textContent = updatingText;
          updateBtn.disabled = true;
        }

        // Submit form after a short delay to allow for multiple changes
        clearTimeout(window.cartUpdateTimeout);
        window.cartUpdateTimeout = setTimeout(() => {
          form.submit();
        }, 500);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const header = document.getElementById('main-header');
    const topBar = document.querySelector('.header__top-bar');
    const mobileToggle = document.querySelector('.header__mobile-toggle');
    const mobileSearchToggle = document.querySelector('.header__mobile-search-toggle');
    const nav = document.getElementById('header-nav');
    const searchForm = document.querySelector('.header__search-form');
    
    // Mobile menu toggle functionality
    if (mobileToggle && nav) {
      mobileToggle.addEventListener('click', function() {
        mobileToggle.classList.toggle('active');
        nav.classList.toggle('active');
        document.body.classList.toggle('nav-open');
      });

      // Close mobile menu when clicking on links
      const menuLinks = nav.querySelectorAll('.header__menu-link');
      menuLinks.forEach(link => {
        link.addEventListener('click', function() {
          mobileToggle.classList.remove('active');
          nav.classList.remove('active');
          document.body.classList.remove('nav-open');
        });
      });

      // Close mobile menu when clicking outside
      document.addEventListener('click', function(e) {
        if (!nav.contains(e.target) && !mobileToggle.contains(e.target)) {
          mobileToggle.classList.remove('active');
          nav.classList.remove('active');
          document.body.classList.remove('nav-open');
        }
      });

      // Close mobile menu when clicking on the close button (::before pseudo-element)
      nav.addEventListener('click', function(e) {
        if (e.target === nav) {
          mobileToggle.classList.remove('active');
          nav.classList.remove('active');
          document.body.classList.remove('nav-open');
        }
      });
    }

    // Mobile search toggle functionality
    const mobileSearchOverlay = document.querySelector('.header__mobile-search-overlay');
    const mobileSearchClose = document.querySelector('.header__mobile-search-close');
    
    if (mobileSearchToggle && mobileSearchOverlay) {
      mobileSearchToggle.addEventListener('click', function() {
        mobileSearchOverlay.classList.add('active');
        document.body.classList.add('search-open');
        const searchInput = mobileSearchOverlay.querySelector('.header__mobile-search-input');
        if (searchInput) {
          setTimeout(() => searchInput.focus(), 100);
        }
      });
    }

    if (mobileSearchClose && mobileSearchOverlay) {
      mobileSearchClose.addEventListener('click', function() {
        mobileSearchOverlay.classList.remove('active');
        document.body.classList.remove('search-open');
      });
    }

    // Close mobile search when clicking outside
    if (mobileSearchOverlay) {
      mobileSearchOverlay.addEventListener('click', function(e) {
        if (e.target === mobileSearchOverlay) {
          mobileSearchOverlay.classList.remove('active');
          document.body.classList.remove('search-open');
        }
      });
    }
    
    // Only apply sticky behavior on homepage (transparent header) for desktop
    const isHomepage = header && header.classList.contains('header--transparent');
    const isMobileOrTablet = window.innerWidth <= 1024;
    
    // Force sticky mode on mobile/tablet on initial load
    if (header && isMobileOrTablet && header.classList.contains('header--transparent')) {
      header.classList.remove('header--transparent');
      header.classList.add('header--sticky');
    }
    
    if (header && isHomepage && !isMobileOrTablet) {
      let lastScrollY = window.scrollY;
      
      function updateHeader() {
        const scrollY = window.scrollY;
        const topBarHeight = topBar ? topBar.offsetHeight : 0;
        
        if (scrollY > topBarHeight) {
          header.classList.remove('header--transparent');
          header.classList.add('header--sticky');
        } else {
          header.classList.remove('header--sticky');
          header.classList.add('header--transparent');
        }
        
        lastScrollY = scrollY;
      }
      
      // Initial check
      updateHeader();
      
      // Listen for scroll events
      window.addEventListener('scroll', updateHeader, { passive: true });
      
      // Listen for resize events
      window.addEventListener('resize', updateHeader, { passive: true });
    }

    // Handle resize events to check if we need to enable/disable transparent behavior
    window.addEventListener('resize', function() {
      const isMobileOrTabletNow = window.innerWidth <= 1024;
      
      if (isMobileOrTabletNow && header && header.classList.contains('header--transparent')) {
        // Force sticky mode on mobile/tablet
        header.classList.remove('header--transparent');
        header.classList.add('header--sticky');
      } else if (!isMobileOrTabletNow && header && header.classList.contains('header--sticky') && isHomepage) {
        // Restore transparent mode on desktop
        header.classList.remove('header--sticky');
        header.classList.add('header--transparent');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('.hero-carousel__swiper');
    if (!carousel) return;

    // Initialize Swiper
    const swiper = new Swiper(carousel, {
      // Basic settings
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      speed: 800,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      
      // Navigation
      navigation: {
        nextEl: '.hero-carousel__button-next',
        prevEl: '.hero-carousel__button-prev',
      },
      
      // Pagination
      pagination: {
        el: '.hero-carousel__pagination',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      },
      
      // Keyboard control
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      
      // Touch/Swipe - Enhanced for mobile
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,
      touchStartPreventDefault: false,
      touchMoveStopPropagation: false,
      simulateTouch: true,
      allowTouchMove: true,
      
      // Mobile optimizations
      resistance: true,
      resistanceRatio: 0.85,
      touchReleaseOnEdges: true,
      
      // Accessibility
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
      },
      
      // Events
      on: {
        init: function () {
          // Add any initialization logic here
        },
        slideChange: function () {
          // Handle slide change if needed
        },
        touchStart: function () {
          // Pause autoplay on touch start
          this.autoplay.stop();
        },
        touchEnd: function () {
          // Resume autoplay after touch end
          setTimeout(() => {
            this.autoplay.start();
          }, 1000);
        }
      }
    });

    // Pause autoplay when user interacts with the carousel
    carousel.addEventListener('mouseenter', () => {
      swiper.autoplay.stop();
    });
    
    carousel.addEventListener('mouseleave', () => {
      swiper.autoplay.start();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popular-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Find all popular products sections
    const popularProductsSections = document.querySelectorAll('.popular-products');
    
    popularProductsSections.forEach(function(section) {
      const swiperContainer = section.querySelector('.popular-products__swiper');
      if (!swiperContainer) return;
      
      // Get the unique swiper ID for this section
      const swiperId = swiperContainer.className.split(' ').find(cls => cls.startsWith('swiper-'));
      if (!swiperId) return;
      
      // Find navigation buttons for this specific section
      const prevButton = section.querySelector('.popular-products__button-prev[data-swiper-target="' + swiperId + '"]');
      const nextButton = section.querySelector('.popular-products__button-next[data-swiper-target="' + swiperId + '"]');
      
      // Initialize Swiper for this specific section
      const swiper = new Swiper(swiperContainer, {
        // Basic settings
        loop: false,
        slidesPerView: 1,
        spaceBetween: 15,
        speed: 500,
        
        // Responsive breakpoints - Enhanced for mobile
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          480: {
            slidesPerView: 1.2,
            spaceBetween: 12,
          },
          640: {
            slidesPerView: 1.5,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 25,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 30,
          }
        },
        
        // Navigation - specific to this section
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        
        // Touch/Swipe - Enhanced for mobile
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,
        touchStartPreventDefault: false,
        touchMoveStopPropagation: false,
        simulateTouch: true,
        allowTouchMove: true,
        resistance: true,
        resistanceRatio: 0.85,
        touchReleaseOnEdges: true,
        
        // Mobile optimizations
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        
        // Accessibility
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('.product-variant-button');
    if (!button || button.disabled) return;

    const form = button.closest('form');
    if (!form) return;

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    const wrapper = button.closest('.product-variants');

    if (wrapper) {
      wrapper.querySelectorAll('.product-variant-button').forEach(function(btn) {
        btn.classList.remove('is-active');
      });
    }

    button.classList.add('is-active');

    variantInput.value = button.dataset.variantId;

    const skuValue = document.querySelector('.product-sku-value');
    if (skuValue) {
      skuValue.textContent = button.dataset.variantSku || '';
    }

    const priceCurrent = document.querySelector('.product-price-current');
    if (priceCurrent) {
      priceCurrent.textContent = button.dataset.variantPrice || '';
    }

    const selectedVariant = JSON.parse(
      document.querySelector('[data-product-json]').textContent
    ).variants.find(function(variant) {
      return String(variant.id) === String(variantInput.value);
    });

    if (selectedVariant) {
      const priceCurrent = document.querySelector('.product-price-current');
      const skuValue = document.querySelector('.product-sku-value');

      if (priceCurrent) {
        priceCurrent.textContent = new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: 'AUD'
        }).format(selectedVariant.price / 100);
      }

      if (skuValue) {
        skuValue.textContent = selectedVariant.sku || '';
      }

      console.log(
        'PRICE UPDATED:',
        selectedVariant.id,
        selectedVariant.price,
        selectedVariant.sku
      );
    }
  });

  document.addEventListener('click', function(event) {
    const toggle = event.target.closest('[data-variant-toggle]');
    if (!toggle) return;

    const form = toggle.closest('form');
    if (!form) return;

    const buttons = form.querySelector('[data-variant-buttons]');
    if (!buttons) return;

    const expanded = buttons.classList.toggle('is-expanded');

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.textContent = expanded ? 'Show fewer sizes' : 'View all sizes';
  });
  
// Helper: update selected Shopify variant
function updateProductVariant(form, variant) {
  if (!form || !variant) return;

  const variantInput = form.querySelector('input[name="id"]');

  if (variantInput) {
    variantInput.value = variant.id;
  }

  const productInfo = form.closest('.product-info') || document;

  const priceCurrent = productInfo.querySelector('.product-price-current');
  if (priceCurrent) {
    priceCurrent.textContent = new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD'
    }).format(variant.price / 100);
  }

  const skuValue = productInfo.querySelector('.product-sku-value');
  if (skuValue) {
    skuValue.textContent = variant.sku || '';
  }
}


// Normal product options, including Awning Length + Hardware Size
document.addEventListener('click', function(event) {
  const button = event.target.closest('.product-option-button');
  if (!button) return;

  // Window selector is handled separately below
  if (
    button.classList.contains('window-height-button') ||
    button.classList.contains('window-width-button')
  ) {
    return;
  }

  const form = button.closest('form');
  if (!form) return;

  const group = button.closest('.product-variant-group');
  if (!group) return;

  // Active state only inside this option group
  group.querySelectorAll('.product-option-button').forEach(function(btn) {
    btn.classList.remove('is-active');
  });

  button.classList.add('is-active');

  // Read selected option values
  const selectedOptions = [];

  form.querySelectorAll('.product-variant-group').forEach(function(optionGroup) {
    const activeButton = optionGroup.querySelector(
      '.product-option-button.is-active'
    );

    if (!activeButton) return;

    const position = parseInt(
      optionGroup.dataset.optionPosition,
      10
    );

    if (!position) return;

    selectedOptions[position - 1] =
      activeButton.dataset.optionValue;
  });

  const productJson = document.querySelector('[data-product-json]');
  if (!productJson) return;

  const product = JSON.parse(productJson.textContent);

  const matchedVariant = product.variants.find(function(variant) {
    return variant.options.every(function(optionValue, index) {
      return optionValue === selectedOptions[index];
    });
  });

  if (!matchedVariant) return;

  updateProductVariant(form, matchedVariant);

  // Sync main gallery image with selected variant
  const variantImage = matchedVariant.featured_image;

  if (variantImage && variantImage.src) {
    const mainImage = document.querySelector(
      '[data-main-product-image]'
    );

    const mainVideo = document.querySelector(
      '[data-main-product-video]'
    );

    const mainWrapper = document.querySelector(
      '.product-main-image-wrapper'
    );

    if (mainImage && mainWrapper) {
      // Stop and hide video if currently playing
      if (mainVideo) {
        const video = mainVideo.querySelector('video');

        if (video) {
          video.pause();
          video.currentTime = 0;
        }

        mainVideo.hidden = true;
      }

      // Display selected variant image
      mainImage.hidden = false;
      mainImage.src = variantImage.src;
      mainImage.removeAttribute('srcset');
      mainImage.alt = variantImage.alt || product.title;

      // Sync gallery thumbnail selection
      const thumbnails = Array.from(
        document.querySelectorAll('[data-product-thumbnail]')
      );

      const matchedThumbnail = thumbnails.find(function(thumbnail) {
        const thumbnailSrc = thumbnail.getAttribute('data-image-src') || '';
        return thumbnailSrc.split('?')[0] === variantImage.src.split('?')[0];
      });

      if (matchedThumbnail) {
        document.querySelectorAll(
          '[data-product-thumbnail], [data-product-video-thumbnail]'
        ).forEach(function(item) {
          item.classList.remove('is-active');
        });

        matchedThumbnail.classList.add('is-active');

        const galleryItems = Array.from(
          document.querySelectorAll(
            '[data-product-thumbnail], [data-product-video-thumbnail]'
          )
        );

        mainWrapper.setAttribute(
          'data-product-image-index',
          galleryItems.indexOf(matchedThumbnail)
        );
      }
    }
  }

  console.log(
    'Variant changed:',
    matchedVariant.id,
    'Price:',
    matchedVariant.price,
    'SKU:',
    matchedVariant.sku
  );

});


  // Window selector: Height + Width
  document.addEventListener('click', function(event) {
    const heightButton = event.target.closest('.window-height-button');
    const widthButton = event.target.closest('.window-width-button');

    if (!heightButton && !widthButton) return;

    const form = event.target.closest('form');
    if (!form) return;

    const selector = event.target.closest('.window-size-selector');
    if (!selector) return;

    // HEIGHT CLICK
    if (heightButton) {
      selector.querySelectorAll('.window-height-button').forEach(function(btn) {
        btn.classList.remove('is-active');
      });

      heightButton.classList.add('is-active');

      const selectedHeight = heightButton.dataset.windowHeight;

      let firstVisibleWidth = null;

      selector.querySelectorAll('.window-width-button').forEach(function(btn) {
        const matches =
          btn.dataset.windowHeight === selectedHeight;

        btn.hidden = !matches;
        btn.classList.remove('is-active');

        if (matches && !firstVisibleWidth) {
          firstVisibleWidth = btn;
        }
      });

      // Automatically select first available width
      if (firstVisibleWidth) {
        firstVisibleWidth.classList.add('is-active');

        const selectedWidth =
          firstVisibleWidth.dataset.windowWidth;

        const fullSizeValue =
          `${selectedHeight} x ${selectedWidth} (H x W)`;

        const productJson =
          document.querySelector('[data-product-json]');

        if (!productJson) return;

        const product =
          JSON.parse(productJson.textContent);

        const optionPosition = parseInt(
          firstVisibleWidth.dataset.optionPosition,
          10
        );

        const normalizeSize = function(value) {
          const numbers = String(value).match(/\d+(?:\.\d+)?/g);
          return numbers ? numbers.slice(0, 2).join('x') : '';
        };

        const targetSize = normalizeSize(fullSizeValue);

        const matchedVariant = product.variants.find(function(variant) {
          const optionValue = variant.options[optionPosition - 1];
          return normalizeSize(optionValue) === targetSize;
        });

        if (!matchedVariant) {
          console.log('No matching window variant:', fullSizeValue);
          return;
        }

        updateProductVariant(form, matchedVariant);
      }

      return;
    }


    // WIDTH CLICK
    if (widthButton) {
      selector.querySelectorAll('.window-width-button').forEach(function(btn) {
        btn.classList.remove('is-active');
      });

      widthButton.classList.add('is-active');

      const activeHeightButton =
        selector.querySelector('.window-height-button.is-active');

      if (!activeHeightButton) return;

      const selectedHeight =
        activeHeightButton.dataset.windowHeight;

      const selectedWidth =
        widthButton.dataset.windowWidth;

      const fullSizeValue =
        `${selectedHeight} x ${selectedWidth} (H x W)`;

      const productJson =
        document.querySelector('[data-product-json]');

      if (!productJson) return;

      const product =
        JSON.parse(productJson.textContent);

      const optionPosition = parseInt(
        widthButton.dataset.optionPosition,
        10
      );

      const normalizeSize = function(value) {
        const numbers = String(value).match(/\d+(?:\.\d+)?/g);
        return numbers ? numbers.slice(0, 2).join('x') : '';
      };

      const targetSize = normalizeSize(fullSizeValue);

      const matchedVariant = product.variants.find(function(variant) {
        const optionValue = variant.options[optionPosition - 1];
        return normalizeSize(optionValue) === targetSize;
      });

      if (!matchedVariant) {
        console.log('No matching window variant:', fullSizeValue);
        return;
      }

      updateProductVariant(form, matchedVariant);

      console.log(
        'Window variant changed:',
        matchedVariant.id,
        fullSizeValue,
        matchedVariant.sku,
        matchedVariant.price
      );
    }
  });

  // Main product gallery - images + Video Guide
  document.addEventListener('click', function(event) {
    const imageThumbnail = event.target.closest('[data-product-thumbnail]');
    const videoThumbnail = event.target.closest('[data-product-video-thumbnail]');
    const prevButton = event.target.closest('[data-gallery-prev]');
    const nextButton = event.target.closest('[data-gallery-next]');

    if (!imageThumbnail && !videoThumbnail && !prevButton && !nextButton) return;

    const mainImage = document.querySelector('[data-main-product-image]');
    const mainVideo = document.querySelector('[data-main-product-video]');
    const mainWrapper = document.querySelector('.product-main-image-wrapper');

    const galleryItems = Array.from(
      document.querySelectorAll(
        '[data-product-thumbnail], [data-product-video-thumbnail]'
      )
    );

    if (!mainImage || !mainWrapper || !galleryItems.length) return;

    let currentIndex = parseInt(
      mainWrapper.getAttribute('data-product-image-index') || '0',
      10
    );

    let newIndex = currentIndex;

    if (imageThumbnail) {
      newIndex = galleryItems.indexOf(imageThumbnail);
    }

    if (videoThumbnail) {
      newIndex = galleryItems.indexOf(videoThumbnail);
    }

    if (prevButton) {
      newIndex = currentIndex - 1;

      if (newIndex < 0) {
        newIndex = galleryItems.length - 1;
      }
    }

    if (nextButton) {
      newIndex = currentIndex + 1;

      if (newIndex >= galleryItems.length) {
        newIndex = 0;
      }
    }

    const selectedItem = galleryItems[newIndex];
    if (!selectedItem) return;

    const isVideo = selectedItem.hasAttribute(
      'data-product-video-thumbnail'
    );

    // Remove active state from every gallery thumbnail
    galleryItems.forEach(function(item) {
      item.classList.remove('is-active');
    });

    selectedItem.classList.add('is-active');

    if (isVideo) {
      // Hide product image
      mainImage.hidden = true;

      // Show Video Guide
      if (mainVideo) {
        mainVideo.hidden = false;
      }
    } else {
      // Stop video when returning to an image
      if (mainVideo) {
        const video = mainVideo.querySelector('video');

        if (video) {
          video.pause();
          video.currentTime = 0;
        }

        mainVideo.hidden = true;
      }

      // Restore product image
      mainImage.hidden = false;

      const newSrc = selectedItem.getAttribute('data-image-src');
      const newAlt = selectedItem.getAttribute('data-image-alt') || '';

      if (newSrc) {
        mainImage.setAttribute('src', newSrc);
        mainImage.setAttribute('alt', newAlt);

        // Prevent an old srcset from overriding the selected image
        mainImage.removeAttribute('srcset');
      }
    }

    mainWrapper.setAttribute(
      'data-product-image-index',
      newIndex
    );
  });

  document.addEventListener('DOMContentLoaded', function() {

    // Auto-expand if selected variant is outside the first 8 sizes
    const variantButtons = document.querySelector('[data-variant-buttons]');
    const variantToggle = document.querySelector('[data-variant-toggle]');

    if (variantButtons && variantToggle) {
      const allButtons = Array.from(
        variantButtons.querySelectorAll('.product-variant-button')
      );

      const activeIndex = allButtons.findIndex(function(button) {
        return button.classList.contains('is-active');
      });

      if (activeIndex >= 8) {
        variantButtons.classList.add('is-expanded');
        variantToggle.setAttribute('aria-expanded', 'true');
        variantToggle.textContent = 'Show fewer sizes';
      }
    }

    // Handle product form submission
    const productForm = document.querySelector('.product-form-inner');
    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const activeVariantButton = this.querySelector('.product-variant-button.is-active');
        const quantityInput = this.querySelector('input[name="quantity"]');

        const variantId = activeVariantButton
          ? activeVariantButton.dataset.variantId
          : this.querySelector('input[name="id"]')?.value;

        const quantity = quantityInput ? quantityInput.value : 1;

        if (!variantId) {
          console.error('No variant selected');
          return;
        }


        // Add to cart using Shopify's Cart API
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId),
              quantity: parseInt(quantity)
            }]
          })
        })
        .then(response => response.json())
        .then(data => {
          // Redirect to cart page on success
          window.location.href = '/cart';
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          alert('Something went wrong. Please try again.');
        });
      });
    }


    // Infinite scroll loading for additional images
    const loadMoreButton = document.querySelector('[data-load-more-images]');
    const additionalImages = document.querySelector('[data-additional-images]');
    
    if (loadMoreButton && additionalImages) {
      loadMoreButton.addEventListener('click', function() {
        // Show additional images with animation
        additionalImages.style.display = 'block';
        
        // Animate each additional image
        const additionalImageItems = additionalImages.querySelectorAll('.product-image-item--additional');
        additionalImageItems.forEach((item, index) => {
          setTimeout(() => {
            item.classList.add('loaded');
          }, index * 100); // Stagger animation
        });
        
        // Hide the button
        this.style.display = 'none';
      });
    }

    // Image magnifier functionality
    const magnifierModal = document.getElementById('product-image-magnifier');
    const magnifierImage = document.querySelector('[data-magnifier-image]');
    const magnifierClose = document.querySelector('[data-modal-close]');
    const magnifierPrev = document.querySelector('[data-magnifier-prev]');
    const magnifierNext = document.querySelector('[data-magnifier-next]');

    const mainGalleryImage = document.querySelector('[data-main-product-image]');
    const mainGalleryWrapper = document.querySelector('.product-main-image-wrapper');

    const galleryThumbnails = Array.from(
      document.querySelectorAll('[data-product-thumbnail]')
    );

    let currentMagnifierIndex = 0;

    function showMagnifierImage(index) {
      if (!magnifierImage || !galleryThumbnails.length) return;

      if (index < 0) {
        index = galleryThumbnails.length - 1;
      }

      if (index >= galleryThumbnails.length) {
        index = 0;
      }

      currentMagnifierIndex = index;

      const thumbnail = galleryThumbnails[index];

      const src = thumbnail.getAttribute('data-image-src');
      const alt = thumbnail.getAttribute('data-image-alt') || '';

      if (!src) return;

      magnifierImage.src = src;
      magnifierImage.alt = alt;
    }

    function openMagnifier() {
      if (!magnifierModal || !magnifierImage || !galleryThumbnails.length) {
        console.log('Magnifier missing:', {
          modal: !!magnifierModal,
          image: !!magnifierImage,
          thumbnails: galleryThumbnails.length
        });
        return;
      }

      showMagnifierImage(currentMagnifierIndex);

      magnifierModal.setAttribute('data-modal-open', 'true');
      document.body.style.overflow = 'hidden';

      console.log('Magnifier opened:', currentMagnifierIndex);
    }

    function closeMagnifier() {
      if (!magnifierModal) return;

      magnifierModal.setAttribute('data-modal-open', 'false');
      document.body.style.overflow = '';
    }

  document.addEventListener('click', function(e) {
    const zoomTrigger = e.target.closest('[data-zoom-trigger]');

    if (!zoomTrigger) return;

    // 点击主图左右切换箭头时，不打开放大图
    if (
      e.target.closest('[data-gallery-prev]') ||
      e.target.closest('[data-gallery-next]')
    ) {
      return;
    }

    currentMagnifierIndex = parseInt(
      zoomTrigger.getAttribute('data-product-image-index') || '0',
      10
    );

    openMagnifier();
  });

    if (magnifierPrev) {
      magnifierPrev.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        showMagnifierImage(currentMagnifierIndex - 1);
      });
    }

    if (magnifierNext) {
      magnifierNext.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        showMagnifierImage(currentMagnifierIndex + 1);
      });
    }

    if (magnifierClose) {
      magnifierClose.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        closeMagnifier();
      });
    }

    if (magnifierModal) {
      magnifierModal.addEventListener('click', function(e) {
        if (e.target === magnifierModal) {
          closeMagnifier();
        }
      });
    }

    document.addEventListener('keydown', function(e) {
      if (
        !magnifierModal ||
        magnifierModal.getAttribute('data-modal-open') !== 'true'
      ) {
        return;
      }

      if (e.key === 'Escape') {
        closeMagnifier();
      } else if (e.key === 'ArrowLeft') {
        showMagnifierImage(currentMagnifierIndex - 1);
      } else if (e.key === 'ArrowRight') {
        showMagnifierImage(currentMagnifierIndex + 1);
      }
    });

    // Read more functionality
    const readMoreTriggers = document.querySelectorAll('[data-read-more-trigger]');
    readMoreTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const description = this.previousElementSibling;
        if (description) {
          description.style.maxHeight = 'none';
          this.style.display = 'none';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('.swiper-related-products');
    if (!carousel) return;

    // Initialize Swiper for related products
    const swiper = new Swiper(carousel, {
      // Basic settings
      loop: false,
      slidesPerView: 1,
      spaceBetween: 15,
      speed: 500,
      
      // Responsive breakpoints
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
        }
      },
      
      // Navigation
      navigation: {
        nextEl: '.related-products__button-next',
        prevEl: '.related-products__button-prev',
      },
      
      // Touch/Swipe
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,
      
      // Accessibility
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous products',
        nextSlideMessage: 'Next products',
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
